module.exports = __webpack_public_path__ + "img/360ext-white.896591f2.svg";